import { useState } from "react";
import { assetUrl, postForm } from "../utils.jsx";
import { Icon } from "../Icon.jsx";

function Modal({ children, title, onClose, wide = false }) {
  return (
    <dialog
      open
      className="sq-overlay"
      aria-modal="true"
      aria-label={title}
    >
      <section className={`sq-modal${wide ? " is-wide" : ""}`}>
        <button
          type="button"
          className="sq-modal-close"
          onClick={onClose}
          aria-label="Tutup"
        >
          <Icon name="close" />
        </button>
        {children}
      </section>
    </dialog>
  );
}

export function AssessmentSection({ config }) {
  const [open, setOpen] = useState(false);
  const [step, setStep] = useState(0);
  const [score, setScore] = useState({ yes: 0, no: 0 });
  const [result, setResult] = useState(null);
  const questions = config.questions || [];
  const answer = (value) => {
    const invert = step === 2 || step === 7;
    const positive = invert ? value === "no" : value === "yes";
    const nextScore = {
      ...score,
      [positive ? "yes" : "no"]: score[positive ? "yes" : "no"] + 1,
    };
    setScore(nextScore);
    if (step >= questions.length - 1)
      setResult(nextScore.yes > nextScore.no ? "strong" : "risk");
    else setStep((current) => current + 1);
  };
  const close = () => {
    setOpen(false);
    setStep(0);
    setScore({ yes: 0, no: 0 });
    setResult(null);
  };
  return (
    <section className="sq-assessment">
      <div className="sq-react-container">
        <div className="sq-assessment__copy">
          <img src={assetUrl("templates/fe/images/shield-1.png")} alt="" />
          <span className="sq-section-kicker">Security check</span>
          <h2>
            {config.lang === "EN"
              ? "IS YOUR BUSINESS DIGITALLY SECURE?"
              : "APAKAH BISNIS ANDA SUDAH TERLINDUNGI?"}
          </h2>
          {config.content?.[1]?.banner_title && (
            <p>
              {
                new DOMParser().parseFromString(
                  config.content[1].banner_title,
                  "text/html",
                ).body.textContent
              }
            </p>
          )}
          <button
            type="button"
            className="sq-primary-button"
            onClick={() => setOpen(true)}
          >
            {config.labels["start-btn"]}
          </button>
        </div>
        <img
          src={assetUrl(
            config.content?.[1]?.image_banner ||
              "templates/fe/images/digital-secure.png",
          )}
          alt="Cyber security assessment"
          loading="lazy"
        />
      </div>
      {open && (
        <Modal title="Digital security assessment" onClose={close}>
          {!result ? (
            <>
              <span className="sq-section-kicker">
                Digital security assessment
              </span>
              <div className="sq-assessment-progress">
                <span
                  style={{
                    width: `${((step + 1) / Math.max(questions.length, 1)) * 100}%`,
                  }}
                />
              </div>
              <p className="sq-assessment-count">
                {step + 1} / {Math.max(questions.length, 1)}
              </p>
              <h2>
                {questions[step]?.question || "Your assessment is ready."}
              </h2>
              <div className="sq-modal-actions">
                <button
                  type="button"
                  className="sq-secondary-button"
                  onClick={() => answer("no")}
                >
                  {config.labels["btn-no"]}
                </button>
                <button
                  type="button"
                  className="sq-primary-button"
                  onClick={() => answer("yes")}
                >
                  {config.labels["btn-yes"]}
                </button>
              </div>
            </>
          ) : (
            <>
              <Icon
                name={result === "strong" ? "verified_user" : "gpp_maybe"}
                className="sq-result-icon"
              />
              <h2>
                {result === "strong"
                  ? config.labels["title-modal-result-success"]
                  : config.labels["title-modal-result-failed"]}
              </h2>
              <p>
                {result === "strong"
                  ? config.labels["desc-1-modal-result-success"]
                  : config.labels["desc-1-modal-result-failed"]}
              </p>
              <a className="sq-primary-button" href={config.urls.consult}>
                {config.labels["consult-with-us-btn"]}
              </a>
            </>
          )}
        </Modal>
      )}
    </section>
  );
}

export function TourModal({ config, open, onClose }) {
  const [stage, setStage] = useState(
    document.cookie.includes("reg_guest=") ? "welcome" : "form",
  );
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState("");
  if (!open) return null;
  const submit = async (event) => {
    event.preventDefault();
    setBusy(true);
    setMessage("");
    try {
      await postForm(
        config.urls.guestRegistration,
        event.currentTarget,
        config.csrfToken,
      );
      document.cookie = "reg_guest=true;max-age=86400;path=/;SameSite=Lax";
      event.currentTarget.reset();
      setStage("welcome");
    } catch (error) {
      setMessage(error.message);
    } finally {
      setBusy(false);
    }
  };
  return (
    <Modal title="SOC virtual tour" onClose={onClose} wide={stage === "tour"}>
      {stage === "form" && (
        <form className="sq-tour-form" onSubmit={submit}>
          <span className="sq-section-kicker">
            {config.labels["title-1-modal-tour"]}
          </span>
          <h2>{config.labels["title-2-modal-tour"]}</h2>
          <div className="sq-form-grid">
            <label>
              {config.labels["fullname-modal-tour"]}*
              <input name="fullname" required maxLength={100} autoComplete="name" />
            </label>
            <label>
              {config.labels["job-modal-tour"]}*
              <input name="jobPosition" required maxLength={100} />
            </label>
            <label>
              {config.labels["company-modal-tour"]}*
              <input name="companyName" required maxLength={150} autoComplete="organization" />
            </label>
            <label>
              {config.labels["industries-modal-tour"]}*
              <select name="typeIndustrie" required defaultValue="">
                <option value="" disabled>
                  Select industry
                </option>
                {config.guestIndustries.map((item) => (
                  <option key={item.id} value={item.menu_value}>
                    {item.menu_value}
                  </option>
                ))}
              </select>
            </label>
            <label>
              {config.labels["email-modal-tour"]}*
              <input name="email" type="email" required maxLength={190} autoComplete="email" />
            </label>
            <label>
              {config.labels["contact-modal-tour"]}*
              <input
                name="contactNumber"
                type="tel"
                required
                maxLength={30}
                pattern="[+\d][\d\s()\-]{6,24}"
                title="Enter a valid phone number"
                autoComplete="tel"
              />
            </label>
          </div>
          <input
            type="text"
            name="website"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            style={{ position: "absolute", left: "-9999px" }}
          />
          <label
            style={{
              display: "flex",
              gap: 8,
              alignItems: "flex-start",
              margin: "12px 0",
            }}
          >
            <input type="checkbox" name="consent" required />
            <span>
              {config.labels["consent-guest"] || (
                <>
                  Saya menyetujui data pribadi yang saya kirimkan disimpan dan
                  diproses oleh SQURA untuk keperluan layanan sesuai{" "}
                  <a
                    href="https://www.lintasarta.net/privacy-notice/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Privacy Notice
                  </a>
                  .
                </>
              )}
            </span>
          </label>
          {message && (
            <p className="sq-form-message is-error" role="alert">
              {message}
            </p>
          )}
          <div className="sq-modal-actions">
            <button
              type="button"
              className="sq-secondary-button"
              onClick={onClose}
            >
              {config.labels["btn-cancel"]}
            </button>
            <button className="sq-primary-button" disabled={busy}>
              {busy ? "Sending..." : config.labels["btn-continue"]}
            </button>
          </div>
        </form>
      )}
      {stage === "welcome" && (
        <div className="sq-tour-welcome">
          <span className="sq-section-kicker">
            {config.labels["title-1-welcome"]}
          </span>
          <h2>{config.labels["title-2-welcome"]}</h2>
          <p>{config.labels["desc-welcome"]}</p>
          <button
            className="sq-primary-button"
            type="button"
            onClick={() => setStage("tour")}
          >
            {config.labels["btn-welcome"]}
          </button>
        </div>
      )}
      {stage === "tour" && (
        <iframe
          className="sq-tour-frame"
          title="SQURA Security Operation Center virtual tour"
          src={
            config.homepage?.panorama_office_url ||
            "https://www.lintasarta.net/"
          }
        />
      )}
    </Modal>
  );
}

export function SiteFooter({ config }) {
  const [message, setMessage] = useState("");
  const [busy, setBusy] = useState(false);
  const subscribe = async (event) => {
    event.preventDefault();
    setBusy(true);
    setMessage("");
    try {
      await postForm(
        config.urls.subscribe,
        event.currentTarget,
        config.csrfToken,
      );
      event.currentTarget.reset();
      setMessage(config.labels["msg-subscribe"]);
    } catch (error) {
      setMessage(error.message);
    } finally {
      setBusy(false);
    }
  };
  return (
    <footer className="sq-react-footer">
      <div className="sq-react-container sq-react-footer__grid">
        <div className="sq-react-footer__brand">
          <img src={assetUrl("templates/fe/images/squra.png")} alt="SQURA" />
          <p>Humanized cyber security solutions for resilient businesses.</p>
          <a className="sq-primary-button" href={config.urls.consult}>
            {config.labels["consult-with-us-btn"]}
          </a>
        </div>
        <div className="sq-react-footer__links">
          {config.menus.map((item) => (
            <a
              key={item.id}
              href={`/${(config.lang === "ID" ? item.menu_link_id : item.menu_link).replace(/^\/+/, "")}`}
            >
              {config.lang === "ID" ? item.menu_value_id : item.menu_value}
            </a>
          ))}
          <a href={config.urls.resources}>Resources</a>
        </div>
        <form className="sq-subscribe" onSubmit={subscribe}>
          <h2>{config.labels["title-subscribe"]}</h2>
          <label>
            <span className="sq-visually-hidden">Email</span>
            <input
              name="email"
              type="email"
              required
              maxLength={190}
              placeholder={config.labels["placeholder-subscribe"]}
            />
          </label>
          <input
            type="text"
            name="website"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            style={{ position: "absolute", left: "-9999px" }}
          />
          <label
            style={{
              display: "flex",
              gap: 8,
              alignItems: "flex-start",
              fontSize: 12,
              margin: "8px 0",
            }}
          >
            <input type="checkbox" name="consent" required />
            <span>
              {config.labels["consent-subscribe"] || (
                <>
                  Saya menyetujui email saya disimpan dan diproses oleh SQURA
                  sesuai{" "}
                  <a
                    href="https://www.lintasarta.net/privacy-notice/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Privacy Notice
                  </a>
                  .
                </>
              )}
            </span>
          </label>
          <button className="sq-primary-button" disabled={busy}>
            {busy ? "Sending..." : config.labels["btn-subscribe"]}
          </button>
          {message && (
            <output className="sq-form-message">
              {message}
            </output>
          )}
        </form>
      </div>
      <div className="sq-react-footer__bottom">
        <p>© {config.labels.copyright}</p>
        <div>
          {config.socialMedia.map((item) => (
            <a
              key={item.id || item.url}
              href={item.url}
              target="_blank"
              rel="noreferrer"
            >
              <img
                src={assetUrl(item.icon_path)}
                alt={item.name || "Social media"}
              />
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
}
